import ConfigProvider from '@arco-design/web-react/es/ConfigProvider';
export default ConfigProvider;
//# sourceMappingURL=index.js.map